// extracted by mini-css-extract-plugin
export default {"container":"AdminManageCategories_container__vruAZ"};